import script from "./SupportsFormPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SupportsFormPage.vue?vue&type=script&setup=true&lang=js"

import "./SupportsFormPage.vue?vue&type=style&index=0&id=073939b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-073939b4"]])

export default __exports__